import React from 'react';
import { Route } from 'react-router-dom';

import { TrackedRoutes } from '../../components/TrackedRoutes';

import { WorkspaceDetail, WorkspaceList } from './components';

export const WorkspacesPage: React.FC = () => (
  <TrackedRoutes>
    <Route index element={<WorkspaceList />} />
    {/* The open tab is part of the address, so a workspace tab can be linked
        and survives a reload. Without one, Directory is shown. */}
    <Route path=":workspaceId" element={<WorkspaceDetail />} />
    <Route path=":workspaceId/:tab" element={<WorkspaceDetail />} />
  </TrackedRoutes>
);
